import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { MdError } from 'react-icons/md';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error('ErrorBoundary caught an error', error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        window.location.href = '/dashboard'; // Safe redirect
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light py-5">
                    <Card className="border-0 shadow-lg" style={{ maxWidth: '600px', width: '90%' }}>
                        <CardBody className="text-center p-5">
                            <MdError size={80} className="text-danger mb-4" />
                            <h2 className="mb-3">Something went wrong</h2>
                            <p className="text-muted mb-4">
                                The application encountered an unexpected error.
                            </p>

                            {this.state.error && (
                                <div className="text-start bg-light p-3 rounded mb-4 overflow-auto" style={{ maxHeight: '60vh', fontSize: '0.85rem' }}>
                                    <code className="text-danger">
                                        {this.state.error.toString()}
                                    </code>
                                    {this.state.errorInfo && (
                                        <pre className="mt-2 text-muted" style={{ fontSize: '0.75rem' }}>
                                            {this.state.errorInfo.componentStack}
                                        </pre>
                                    )}
                                </div>
                            )}

                            <div className="d-grid gap-2 d-sm-flex justify-content-center">
                                <Button color="primary" onClick={this.handleReset}>
                                    Return to Dashboard
                                </Button>
                                <Button color="outline-secondary" onClick={() => window.location.reload()}>
                                    Reload Page
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
